import {
  useTable,
  usePagination,
  useGroupBy,
  useSortBy,
  Column,
} from 'react-table';
import { Table as TableComponent } from '../../styles/components';

interface TableProperties {
  pageCount: number;
  columns: Column[];
  data: Array<any>;
  id?: string;
}

export function Table({ data, columns, id }: TableProperties) {
  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, rows } =
    useTable(
      {
        columns,
        data,
        initialState: {},
      },
      useGroupBy,
      useSortBy,
      usePagination,
    );

  return (
    <>
      <TableComponent responsive {...getTableProps()} id={id}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  title={String(column.Header) || ''}
                >
                  <h6 className="d-flex align-items-center mb-0">
                    {column.render('Header')}
                    <span>
                      {column.isSorted ? (
                        column.isSortedDesc ? (
                          <small style={{ fontSize: '1.5rem' }}>&#8595;</small>
                        ) : (
                          <small style={{ fontSize: '1.5rem' }}>&#8593;</small>
                        )
                      ) : (
                        <small />
                      )}
                    </span>
                  </h6>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map(row => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => (
                  <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </TableComponent>
    </>
  );
}
